import React from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ErrorAlert } from "components/alert";
import Navbars from 'routers/navbars';
import Footer from 'components/footer';
import { Button, Form, FormGroup, Input, InputGroup } from 'reactstrap';
import { PROVINCE_LIST } from './components/province';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBath, faBed, faChevronDown, faChevronUp, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import Pagination from './pagination/Pagination';
import { Helmet, HelmetData } from 'react-helmet-async';

const path_url = process.env.REACT_APP_API_CONNECT;
const helmetData = new HelmetData({});

function LandForSale(){
    // const [isOpen, setIsOpen] = React.useState(false);
    const { area } = useParams();
    const [fetch, setFetch] = React.useState(null);
    const [pageSize] = React.useState(10);
    const [pageCurent, setPageCurent] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(0);
    const [selectProvince, setSelectProvince] = React.useState("")

    React.useEffect(() =>{
        fetchData(1)
    },[])

    const fetchData = async (page) =>{
        const skip = (page - 1) * pageSize;
        try{
            setSelectProvince(area)
            const res = await axios.post(path_url+'/landforsale/getfrom_area',{
                area: area,
                skip: skip
            })
            if(res.status === 200){
                setFetch(res?.data?.areas)
                setTotalPage(res?.data?.count)
            }
        }catch(e){
            ErrorAlert({text: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'})
        }
    }

    function _onChangePage(val){
        setPageCurent(val)
        fetchData(val)
        scrollToTop()
    }

    const intl = new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
        minimumFractionDigits: 0,
    })

    function onChangeProvince(e){
        if(e.key === "Enter"){
            window.location.href = `/landforsale/${selectProvince}`
        }
        // history.push(`/landforsale/${province}`)
        
        // setSelectProvince(province)
    }

    const toEstateDetail = (val) =>{
        window.open(`/estate_detail/${val}`, "_blank") 
        // window.location.href = `/EstateDetail/?sale=${val}`
    }

    function scrollToTop(){
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
    }

    return(
        <>
        <Helmet prioritizeSeoTags helmetData={helmetData}>
            <title>{`ค้นหา ${area}`}</title>
            <meta name="title" content={`ค้นหา ${area}`} />
            <meta name="description" content={`ผลการค้นหาจาก "${area}" ${totalPage} รายการ`}/>
            <link rel="canonical" href={`https://www.taladteedin.com/landforsale/${area}`} />
        </Helmet>
        <Navbars/>
        <div className='landforsale-container'>
            <FormGroup className="form-group">
                <InputGroup className='input-group-xl'>
                    <FontAwesomeIcon icon={faLocationDot} style={{marginLeft:5, marginRight:5, color:'#23265F'}} />
                    <Input 
                    list="provinces" 
                    className="form-list color-darkblue" 
                    placeholder="จังหวัด" 
                    defaultValue={selectProvince}
                    onChange={(val) => setSelectProvince(val.target.value)}
                    onKeyUp={(e) => onChangeProvince(e)}
                    />
                    <datalist id="provinces" className="list" >
                        {PROVINCE_LIST?.map((item,i) =>{
                            return <option key={i} className="color-darkblue" value={item.province_name} />
                        })}
                    </datalist>
                </InputGroup>
            </FormGroup>
            {/* <div className={isOpen ? 'wrapper-area open' : 'wrapper-area'}>
                {PROVINCE_LIST?.map((item,i) =>{
                    return(
                        <Button 
                        id={i}
                        className='mr-10 mb-10' 
                        color={item?.province_name === area ? 'default' : 'default-outline'}
                        onClick={() => onChangeProvince(item?.province_name)}
                        >
                            {item?.province_name}
                        </Button>
                    )
                })}
            </div> */}
            {/* <div className='mb-40'>
                {isOpen ? 
                <Button 
                color='transparent' 
                size='sm' 
                style={{width: '100%'}}
                onClick={() => setIsOpen(!isOpen)}
                >
                    ย่อขนาด <FontAwesomeIcon icon={faChevronUp} />
                </Button>
                :
                <Button 
                color='transparent' 
                size='sm' 
                style={{width: '100%'}}
                onClick={() => setIsOpen(!isOpen)}
                >
                    เพิ่มเติม <FontAwesomeIcon icon={faChevronDown} />
                </Button>
                }
            </div> */}
            <div className='wrapper-list mt-50'>
                <h3>ผลการค้นหา "{area}"</h3>
                <p>ผลการค้นหาจาก "{area}" {totalPage} รายการ</p>
                <div className='container-list-item'>
                    {fetch?.map((item, i) =>{
                        return(
                            <div className='item mb-30'>
                                <div className='image-land'> 
                                    <img 
                                    alt={`item-${i}`} 
                                    src={item?.images[0]?.path}
                                    className='item-img'
                                    />
                                </div>
                                <div className='discription'>
                                    <div className='discription-body'>
                                        <p className='title mb-10'>
                                            {item?.title}
                                        </p>
                                        <p className='detail mb-20'>
                                            {item?.description}
                                        </p>
                                        <div className='detail-1'>
                                            {item?.saleCategory === "HOME" || item?.saleCategory === "COMMERCIAL" || item?.saleCategory === "MORE" ?
                                            <div style={{display:'flex'}}>
                                                <div style={{marginRight: 10}}>
                                                    <FontAwesomeIcon icon={faBath} style={{fontSize:16, marginRight: 10}} /><label>{item?.bathRoom} ห้องน้ำ</label>
                                                </div>
                                                <div style={{marginRight: 10}}>
                                                    <FontAwesomeIcon icon={faBed} style={{fontSize:16, marginRight: 10}} /><label>{item?.bedRoom} ห้องนอน</label>
                                                </div>
                                            </div>
                                            :
                                            <div className='color-black'>
                                                {intl.format(item?.pricePerWa)}
                                            </div>
                                            }
                                            <div>
                                                <label className='color-default'>{intl.format(item?.totalPrice)}</label>
                                            </div>
                                        </div>
                                        
                                        
                                    </div>
                                    <div className='discription-bottom'>
                                        <div className='address'>
                                            <FontAwesomeIcon icon={faLocationDot} style={{fontSize: 16, marginRight: 10}} />
                                            {item?.saleDistrict}, {item?.saleProvince}
                                        </div>
                                        <div className='button-end'>
                                            <Button 
                                            color='default' 
                                            size='sm'
                                            onClick={() => toEstateDetail(item?._id)}
                                            > 
                                                View 
                                            </Button>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        )
                    })}
                    
                    <div style={{display:'flex', justifyContent:'center'}}>
                        <Pagination 
                        className="pagination-bar"
                        currentPage={pageCurent}
                        totalCount={totalPage}
                        pageSize={pageSize}
                        onPageChange={page => _onChangePage(page)}
                        />
                    </div>
                    
                </div>
            </div>
            
        </div>
        <Footer/>
        </>
    )
}
export default LandForSale;